import { Navigate } from "react-router-dom";
import { useAccessControl } from "@/hooks/useAccessControl";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

/**
 * Guarda das rotas do Portal do Artista (audiência separada).
 * Só entra quem está autenticado E tem papel `artist` (admin também passa,
 * para suporte). Qualquer outro caso volta para o login do portal — staff
 * do Acervo não acessa o portal, e artista não acessa o app interno.
 */
export function ArtistRoute({ children }: { children: React.ReactNode }) {
  const { authUser, loading, roles, isAdmin } = useAccessControl();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gl-bg-light">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!authUser) {
    return <Navigate to="/portal/login" replace />;
  }

  const isArtist = roles.includes("artist") || isAdmin;
  if (!isArtist) {
    return <Navigate to="/portal/login" replace />;
  }

  return <>{children}</>;
}
